import axiosBase from './axiosBase';

const url = 'https://price.vixs.vn';

const instance = new axiosBase(url, {})

const instanceClient = instance.createInstance()

export default instanceClient;